import { FileExcelOutlined } from "@ant-design/icons";
import "./index.css";
import { HiOutlineCurrencyRupee } from "react-icons/hi2";
import { BiRightArrowAlt, BiSolidPurchaseTag } from "react-icons/bi";

const purchaseItemColumns = [
  {
    columnName: "Price/ Item(₹)",
    key: "Price",
    value: false,
  },
  {
    columnName: "Quantity",
    key: "Qty",
    value: false,
  },
  {
    columnName: "Custom Column",
    key: "CustomColumn",
    value: false,
  },
  {
    columnName: "Travel",
    key: "Travel",
    value: false,
  },
  {
    columnName: "Batch no.",
    key: "batch",
    value: false,
  },
  {
    columnName: "Exp. Date",
    key: "expiryDate",
    value: false,
  },
  {
    columnName: "Mfg Date",
    key: "mfgDate",
    value: false,
  },
];

const createItemsData = [
  {
    columnName: "Item Name",
    key: "itemName",
    value: false,
  },
  {
    columnName: "Item Code",
    key: "itemCode",
    value: false,
  },
  {
    columnName: "Sales Price",
    key: "salesPrice",
    value: false,
  },
  {
    columnName: "Purchase Price",
    key: "purchasePrice",
    value: false,
  },
  {
    columnName: "Current Stock",
    key: "currentStock",
    value: false,
  },
  {
    columnName: "Quantity",
    key: "quantity",
    value: false,
  },
];

const createItemTableData = [
  {
    itemName: "Country Eggs",
    itemCode: "-",
    salesPrice: "-",
    purchasePrice: "-",
    currentStock: "0 pcs",
    quantity: "",
  },
  {
    itemName: "Kadaknath Eggs",
    itemCode: "-",
    salesPrice: "₹ 125",
    purchasePrice: "₹ 100",
    currentStock: "-1 pcs",
    quantity: "",
  },
  {
    itemName: "Fish",
    itemCode: "-",
    salesPrice: "₹ 125",
    purchasePrice: "₹ 100",
    currentStock: "-1 pcs",
    quantity: "",
  },
  {
    itemName: "Labster",
    itemCode: "-",
    salesPrice: "",
    purchasePrice: "",
    currentStock: "1 pcs",
    quantity: "",
  },
];


const HeaderData = [
  {
    key: "date",
    title: "Date",
    dataIndex: "date",
    sorter: (a, b) => a.date.length - b.date.length,
  },
  {
    key: "debitNoteNumber",
    title: "Debit Note Number",
    dataIndex: "debitNoteNumber",
  },
  {
    key: "partyName",
    title: "Party Name",
    dataIndex: "partyName",
  },
  {
    key: "amount",
    title: "Amount",
    dataIndex: "amount",
  },
  {
    key: "status",
    title: "Status",
    dataIndex: "status",
  },
];

const TableData = [
  {
    date: "12 Aug 2024",
    debitNoteNumber: "4",
    partyName: "faisal",
    amount: "₹ 900",
    status: "Unpaid",
  },
  {
    date: "12 Aug 2024",
    debitNoteNumber: "6",
    partyName: "karthick",
    amount: "₹ 300",
    status: "Unpaid",
  },
];
const purchaseHeaders = [
  {
    label: "Total Purchases",
    key: "1",
    icon: <BiSolidPurchaseTag size={16} />,
    amount: "₹ 1,465",
    color: "blue",
  },
  {
    label: "Paid",
    key: "2",
    icon: <HiOutlineCurrencyRupee size={16} />,
    amount: "₹ 336.5",
    color: "green",
  },
  {
    label: "Unpaid",
    key: "3",
    icon: <HiOutlineCurrencyRupee size={16} />,
    amount: "₹ 1,150",
    color: "red",
  },
];
const items = [
  {
    label: <a href="/purchase">GSTR</a>,
    key: "1",
  },
  {
    type: "divider",
  },
  {
    label: <a href="/purchase">Daybook</a>,
    key: "2",
  },
];
const balaceCollectOptions = [
  {
    label: "To Collect",
    value: "toCollect",
  },
  {
    label: "To Pay",
    value: "toPay",
  },
];
const partyFaqList = [
  {
    key: "1",
    label: "Why should I create Parties?",
    children: (
      <p className="text-[12px]">
        Parties are your Customers and Suppliers. To make bills for them, you
        need to add them as a party first.
      </p>
    ),
  },
  {
    key: "2",
    label: "I have too many parties. How to add them easily?",
    children: (
      <p className="text-[12px]">
        myBillBook provides the option to import your parties data from Excel.{" "}
        To start uploading your parties in bulk click here.
      </p>
    ),
  },
  {
    key: "3",
    label: "How to see Party Ledger/Statement?",
    children: (
      <p className="text-[12px]">
        A party's ledger can be seen in two ways: <br />
        1. Select the party in the Parties table and then click on the
        "Ledger(Statement)" tab given at top in the new screen that opens.{" "}
        <br />
        2. You can also open Party Statement by going to Reports from the side
        navigation menu and selecting "Party Statement (Ledger)". After that,
        you can select the party whose Party Statement you want to see.
      </p>
    ),
  },
  {
    key: "4",
    label: "How is Party balance calculated?",
    children: (
      <p className="text-[12px]">
        Party balance is the outstanding amount of money that you need to
        collect from or pay to the party. It is calculated based on the Opening
        Balance you entered while creating the party, the invoices(both sales
        and purchase) you made against the party and the payments you made
        to/received from the party.
      </p>
    ),
  },
  {
    key: "5",
    label: "How to send Invoice SMS to Party?",
    children: (
      <p className="text-[12px]">
        For every Invoice that you create, an SMS is sent automatically to your
        party with a link to that Invoice. Incase you want to turn this feature
        off, you can do that by going to Reminder inside Settings and disabling
        the "Send billing SMS to Party" option. To manually send SMS to Party,
        open the Invoice and click on the SMS button.
      </p>
    ),
  },
  {
    key: "6",
    label: "How to create GST/Non-GST party?",
    children: (
      <p className="text-[12px]">
        While creating a party, enter their GSTIN. Accordingly that party will
        be counted as GST/Non-GST Party. GSTIN along with Place of Supply of
        party will determine whether an Invoice will have IGST or CGST/SGST so
        make sure you fill this information.
      </p>
    ),
  },
];
const partyTypeOptions = [
  {
    label: "Customer",
    value: "customer",
  },
  {
    label: "Supplier",
    value: "supplier",
  },
];
const bulkActions = (
  <div className="hover:rounded-md hover:mr-[-3px] flex justify-between w-[270px] h-[45px] mt-[-12px] pl-3 pr-2 pt-2 pb-2 cursor-pointer">
    <div>
      <p className="flex text-[14px] font-semibold">
        <FileExcelOutlined className="mr-2" /> Bulk Add Parties
      </p>
      <p className="mt-1 text-[12px]">
        Quickly add all your Parties with Excel
      </p>
    </div>
    <BiRightArrowAlt size={24} />
  </div>
);
export {
  items,
  purchaseHeaders,
  balaceCollectOptions,
  TableData,
  partyTypeOptions,
  bulkActions,
  purchaseItemColumns,
  createItemsData,
  HeaderData,
  createItemTableData,
  partyFaqList,
};
